import React from "react";
import loadable from "@loadable/component";
import LoadingRoute from "theme/modules/Router/LoadingRoute";

export const Category = loadable(
  () => import(/* webpackChunkName: "category" */ "theme/pages/Category"),
  {
    fallback: <LoadingRoute />,
  }
);

export const Product = loadable(
  () => import(/* webpackChunkName: "product" */ "theme/pages/Product"),
  {
    fallback: <LoadingRoute />,
  }
);

export const CmsPage = loadable(
  () => import(/* webpackChunkName: "cms-page" */ "theme/pages/CmsPage"),
  {
    fallback: <LoadingRoute />,
  }
);
